import PropTypes from "prop-types";
import * as React from "react";
import { Influencer, SignType } from "../../../../domain";
import { useCurrentUser } from "../../../../globalState";
import AuthDialog from "../../../Auth/AuthDialog";
import * as constants from "../../constants";
import Section from "../../Section";
import CompactThumbnails from "../CompactThumbnails";
import HowItWorks from "../HowItWorks";
import FanReviews from "../FanReviews";

const shopSections = [
  {
    name: "liveAndUpcoming",
    title: "Live & Upcoming",
    look: constants.LOOK_TALL,
    type: constants.INFLUENCER_TYPE,
    updateFavouriteStatus: true,
    href: `/shops?${new URLSearchParams({ o: "ed" })}`,
  },
  {
    name: "featured",
    title: "Featured",
    look: constants.LOOK_TALL,
    type: constants.INFLUENCER_TYPE,
    updateFavouriteStatus: true,
  },
];

const productSections = [
  {
    title: "Fan Favorites",
    name: "popularProducts",
    look: constants.LOOK_PRODUCT,
    type: constants.PRODUCT_TYPE,
    href: "/products",
    updateFavouriteStatus: false,
  },
  {
    title: "Pre-Signed Products",
    name: "presigned",
    look: constants.LOOK_PRODUCT,
    type: constants.PRODUCT_TYPE,
    href: `/products?${new URLSearchParams({
      st: `${SignType.presigned},${SignType.noAutograph}`,
    })}`,
    updateFavouriteStatus: false,
  },
  {
    title: "Signed with Personalized Video",
    name: "signAnytime",
    look: constants.LOOK_PRODUCT,
    type: constants.PRODUCT_TYPE,
    href: `/products?${new URLSearchParams({
      st: `${SignType.anytime}`,
    })}`,
    updateFavouriteStatus: false,
  },
];

const evenMoreSection = {
  name: "evenMore",
  title: "Even More",
  look: constants.LOOK_TALL,
  type: constants.INFLUENCER_TYPE,
  updateFavouriteStatus: true,
  href: "/shops",
};

export default function Main({ isMobile }) {
  const postLoginCbRef = React.useRef(false);
  const [onClose, setOnClose] = React.useState(null);

  const currentUser = useCurrentUser();

  const updateFavouriteStatus = React.useCallback(
    async (influencer, callback) => {
      const { isFavourite } = influencer;

      if (!currentUser?.userId && !postLoginCbRef.current) {
        return setOnClose(() => (user) => {
          const didLogin = Boolean(user);

          setOnClose(null);

          if (!didLogin) {
            return;
          }

          postLoginCbRef.current = true;
          updateFavouriteStatus(influencer, callback);
        });
      }

      try {
        if (influencer.isFavourite) {
          await Influencer.favourite({ influencer });
        } else {
          await Influencer.unfavourite({ influencer });
        }

        return callback(isFavourite);
      } catch (err) {
        console.error(err);
        return callback(!isFavourite);
      }
    },
    [currentUser?.userId],
  );

  return (
    <>
      {shopSections.map((section) => (
        <Section
          currentUser={currentUser}
          isMobile={isMobile}
          key={section.title}
          section={section}
          updateFavouriteStatus={updateFavouriteStatus}
        />
      ))}

      <CompactThumbnails />

      <HowItWorks />

      {productSections.map((section) => (
        <Section
          currentUser={currentUser}
          isMobile={isMobile}
          key={section.title}
          section={section}
          updateFavouriteStatus={updateFavouriteStatus}
        />
      ))}

      <Section
        currentUser={currentUser}
        isMobile={isMobile}
        section={evenMoreSection}
        updateFavouriteStatus={updateFavouriteStatus}
      />

      <FanReviews />

      {Boolean(onClose) && <AuthDialog onClose={onClose} />}
    </>
  );
}

Main.propTypes = {
  isMobile: PropTypes.bool,
};
